module.exports = __webpack_public_path__ + "static/media/Angela Kelly Headshot_1602000102076.9b155073.jpeg";